import React from 'react';
import { Tabs as AntdTabs, type TabsProps as AntdTabsProps } from 'antd';

// Generic tab-navigation surface: AntD `Tabs` props (items/labels, activeKey,
// onChange, per-item icon/disabled, styling hooks, and test hooks) pass through.
// This primitive owns rendering + change handling only — not routing,
// permissions, API/client state, or page-header layout.
export type HeaderTabsProps = AntdTabsProps;

type HeaderTabsComponent = React.ForwardRefExoticComponent<
    HeaderTabsProps & React.RefAttributes<HTMLDivElement>
> & {
    TabPane: typeof AntdTabs.TabPane;
};

// AntD `Tabs` is a plain `React.FC` and does not accept a `ref`. The forwardRef
// shell preserves the house signature/displayName and the render function takes
// both params (props, ref) so React does not warn; `_ref` is intentionally not
// forwarded to the underlying Tabs.
const HeaderTabs = React.forwardRef<HTMLDivElement, HeaderTabsProps>(
    (props, _ref) => <AntdTabs {...props} />,
) as HeaderTabsComponent;

HeaderTabs.displayName = 'HeaderTabs';
HeaderTabs.TabPane = (AntdTabs as typeof AntdTabs | undefined)
    ?.TabPane as typeof AntdTabs.TabPane;

export { AntdTabs };
export default HeaderTabs;
